import {
  FETCH_IDENTITY,
  UPDATE_ACCOUNT,
  REFRESH_API_TOKEN,
  UPDATE_USER,
  FETCH_ACTIVITIES,
  UPDATE_ACCOUNT_IMAGE
} from "./types";
import { LOGIN } from "@/store/auth/types";
import * as accountApi from "@/api-client/account";
import * as userApi from "@/api-client/user";
import {
  convertDataToApi,
  convertDataFromApi,
  collectAddressObjectFromData
} from "@/utils/util";

export default {
  async fetchIdentity({ commit }, { onSuccess } = {}) {
    commit({
      type: FETCH_IDENTITY.request
    });

    try {
      const identity = await Promise.all([
        accountApi.fetchAccount(),
        userApi.fetchUser()
      ]);

      commit({
        type: FETCH_IDENTITY.success,
        payload: {
          account: identity[0],
          user: {
            ...identity[1]
          }
        }
      });

      commit(
        {
          type: `auth/${LOGIN.success}`
        },
        {
          root: true
        }
      );

      onSuccess ? onSuccess(identity) : null;
    } catch (e) {
      commit({
        type: FETCH_IDENTITY.error,
        payload: e.message
      });
    }
  },

  async updateAccount(
    { commit, state },
    { id, values, cb, onError, patch = false } = {}
  ) {
    commit({
      type: UPDATE_ACCOUNT.request
    });
    try {
      let accResp = {};
      let user = {};
      let accountUpdateId = id || state.identity.account.id;

      if (patch) {
        accResp = await accountApi.updateAccount(
          { ...values },
          accountUpdateId
        );
      } else {
        accResp = await accountApi.updateAccount(
          { ...values },
          accountUpdateId
        );

        user = await userApi.updateUser({
          email: values.email,
          first_name: values.firstName,
          last_name: values.lastName
        });
      }

      commit({
        type: UPDATE_ACCOUNT.success,
        payload: {
          account: {
            ...accResp,
            address: convertDataFromApi("address", accResp)
          },
          user
        }
      });
      // callback to container
      cb
        ? cb({
            account: accResp,
            user
          })
        : null;
    } catch (e) {
      commit({
        type: UPDATE_ACCOUNT.error,
        payload: e.message
      });

      onError ? onError(e.message) : null;
    }
  },

  async updateUser({ commit }, { values, onSuccess, onError } = {}) {
    commit({
      type: UPDATE_USER.request
    });

    try {
      const user = await userApi.updateUser(values);
      commit({
        type: UPDATE_USER.success,
        payload: user
      });

      // callback to container
      onSuccess ? onSuccess(user) : null;
    } catch (e) {
      commit({
        type: UPDATE_USER.error,
        payload: e.message
      });

      onError ? onError(e.message) : null;
    }
  },

  async updateAccountImage({ commit }, { file, onSuccess, onError } = {}) {
    commit({
      type: UPDATE_ACCOUNT_IMAGE.request
    });

    try {
      const { image_url } = await userApi.updateAccountImage(file);

      commit({
        type: UPDATE_ACCOUNT_IMAGE.success,
        payload: image_url
      });

      onSuccess && onSuccess();
    } catch (e) {
      commit({
        type: UPDATE_ACCOUNT_IMAGE.error,
        payload: e.message
      });

      onError && onError();
    }
  },

  async refreshApiToken({ commit }, { onSuccess, onError } = {}) {
    commit({
      type: REFRESH_API_TOKEN.request
    });

    try {
      await accountApi.refreshToken();

      commit({
        type: REFRESH_API_TOKEN.success
      });

      onSuccess ? onSuccess() : null;
    } catch (e) {
      commit({
        type: REFRESH_API_TOKEN.error,
        payload: e.message
      });

      onError ? onError(e.message) : null;
    }
  },

  async fetchActivities({ commit }, { onSuccess, onError } = {}) {
    commit({
      type: FETCH_ACTIVITIES.request
    });

    try {
      const activities = await accountApi.fetchActivities();

      commit({
        type: FETCH_ACTIVITIES.success,
        payload: activities.items
      });

      onSuccess ? onSuccess() : null;
    } catch (e) {
      commit({
        type: FETCH_ACTIVITIES.error,
        payload: e.message
      });

      onError ? onError(e.message) : null;
    }
  }
};
